import * as React from 'react';
import { formClasses, TextInputProps } from './TextInput';
import { CountryCode } from 'libphonenumber-js';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { twMerge } from 'tailwind-merge';
import phoneValidator from '@th/shared/src/validators/phoneValidator';
import FieldsLabel from './FieldsLabel';

interface Props extends Omit<TextInputProps, 'id'> {
  id?: string;
  label?: string;
  phone: string;
  setPhone: (string) => void;
  showValid?;
  showInvalid?;
}

const CANADA_COUNTRY_CODE = 'CA' as CountryCode;

export default function PhoneTextInput({
  id = 'phone',
  label,
  phone,
  setPhone,
  placeholder = '647-555-5555',
  showValid,
  showInvalid,
}: Props) {
  const isPhoneValid = phoneValidator.isValidSync(phone);

  return (
    <div>
      {label && <FieldsLabel id={id}>{label}</FieldsLabel>}
      <PhoneInput
        id={id}
        placeholder={placeholder}
        value={phone}
        onChange={setPhone}
        defaultCountry={CANADA_COUNTRY_CODE}
        numberInputProps={{
          className: twMerge(
            formClasses,
            showValid &&
              isPhoneValid &&
              'border-success focus:border-success focus:ring-success',
            showInvalid &&
              !isPhoneValid &&
              'border-error focus:border-error focus:ring-error',
          ),
        }}
      />
    </div>
  );
}
